var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _MemoryStorageStrategy_storage;
import { StorageStrategyErrors } from '../StorageErrors';
import AbstractStorageStrategy from './AbstractStorageStrategy';
class MemoryStorageStrategy extends AbstractStorageStrategy {
    // ESLint ignore is because all storage strategies must have this constructor signature
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    constructor(_dbName) {
        super();
        _MemoryStorageStrategy_storage.set(this, {});
    }
    initialize() {
        return Promise.resolve();
    }
    async getItem(key) {
        return new Promise((resolve) => {
            const value = __classPrivateFieldGet(this, _MemoryStorageStrategy_storage, "f")[key];
            if (!value) {
                resolve(null);
                return;
            }
            resolve(value);
        });
    }
    async setItem(key, value) {
        return new Promise((resolve) => {
            if (__classPrivateFieldGet(this, _MemoryStorageStrategy_storage, "f")[key]) {
                throw new Error(StorageStrategyErrors.KEY_EXISTS);
            }
            __classPrivateFieldGet(this, _MemoryStorageStrategy_storage, "f")[key] = value;
            resolve(value);
        });
    }
    async updateItem(key, value) {
        return new Promise((resolve) => {
            if (!__classPrivateFieldGet(this, _MemoryStorageStrategy_storage, "f")[key]) {
                throw new Error(StorageStrategyErrors.KEY_NOT_EXISTS);
            }
            __classPrivateFieldGet(this, _MemoryStorageStrategy_storage, "f")[key] = value;
            resolve(value);
        });
    }
    async removeItem(key) {
        delete __classPrivateFieldGet(this, _MemoryStorageStrategy_storage, "f")[key];
    }
    async clear() {
        const allKeys = await this.keys();
        for (const key of allKeys) {
            delete __classPrivateFieldGet(this, _MemoryStorageStrategy_storage, "f")[key];
        }
    }
    async key(keyIndex) {
        const keys = await this.keys();
        return keys[keyIndex] ?? null;
    }
    async keys() {
        const keys = Object.keys(__classPrivateFieldGet(this, _MemoryStorageStrategy_storage, "f"));
        return keys;
    }
}
_MemoryStorageStrategy_storage = new WeakMap();
export default MemoryStorageStrategy;
